import { sapApi } from "@/apis/interceptor"
import { ICostCenterMaster, IResponse } from "@/types"

interface ICostCenterMasterAutocompleteResponse {
  items: ICostCenterMaster[]
}

export const costCenterMasterService = {
  getAutocompleteOptions: async (search: string, limit = 10): Promise<IResponse<ICostCenterMasterAutocompleteResponse>> => {
    const response = await sapApi.get<IResponse<ICostCenterMasterAutocompleteResponse>>("/api/v1/cost-center-masters/autocomplete", {
      params: { search, limit },
    })
    return response.data
  },
}
